import React from 'react';

import './index.css';

const Component = (props) => {
    const { items } = props;

    return (
        <div>
            <h5>TPC Member:</h5>
            <p>
                {items.map((item, index) => {
                    return (
                        <span key={index}>
                            {(() => {
                                if (index !== 0) return <span>&bull;&nbsp;&nbsp;</span>;
                                return '';
                            })()}
                            <span>
                                {item.name
                                    .replace(/-/g, '\u{2011}')
                                    .replace(/ /g, '\u00a0')
                                    .replace(/\//g, '\u{2044}')}
                                &nbsp;
                            </span>
                            {
                                // eslint-disable-next-line no-shadow
                                item.versions.map((item, index, arr) => {
                                    return (
                                        <span key={index}>
                                            <a href={item.link} target="blank">
                                                {item.year}
                                            </a>
                                            {(() => {
                                                if (item.remark && item.remark.length > 0)
                                                    return <span>&nbsp;({item.remark})</span>;
                                                return null;
                                            })()}
                                            {(() => {
                                                if (index + 1 !== arr.length)
                                                    return <span>&nbsp;/&nbsp;</span>;
                                                return <span>&nbsp;</span>;
                                            })()}
                                        </span>
                                    );
                                })
                            }
                            &nbsp;&nbsp;
                        </span>
                    );
                })}
            </p>
        </div>
    );
};

export default Component;
